<script>
import {defineComponent} from 'vue'
import SalesDepartmentPhone from "@js/components/Sections/Links/SalesDepartmentPhone.vue";
import CommerceDepartmentPhone from "@js/components/Sections/Links/CommerceDepartmentPhone.vue";
import LogisticDepartmentPhone from "@js/components/Sections/Links/LogisticDepartmentPhone.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import {contacts} from "@js/company_details.ts";
import SalesDepartmentPhone2 from "@js/components/Sections/Links/SalesDepartmentPhone2.vue";
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";

export default defineComponent({
    name: "TopBarContactsBlock",
    methods: {
        contacts() {
            return contacts
        }
    },
    components: {
        IconMapPoint,
        IconEnvelope,
        SalesDepartmentPhone2,
        IconTelegram,
        IconWhatsApp,
        IconPhone,
        LogisticDepartmentPhone,
        CommerceDepartmentPhone,
        SalesDepartmentPhone
    },
    setup() {
        const callbackStore = useCallbackStore()

        return {callbackStore, contacts}
    }
})
</script>

<template>
    <div class="relative p-5 font-normal text-sm text-gray-600">
        <p class="text-base font-semibold mb-1 text-black">
            Вы можете оформить заказ и узнать наличие товара по телефону
        </p>
        <p class="text-sm mb-3">
            Наши специалисты ответят на любой интересующий вопрос
        </p>
        <div class="flex flex-col gap-1.5 text-[16px] text-black mb-3 text-sm text-nowrap">
            <div v-if="contacts.sales_department_phone" class="flex items-center justify-between gap-1">
                Отдел продаж
                <SalesDepartmentPhone class="font-medium md:hover:text-navHoverColor transition"/>
            </div>
            <div v-if="contacts.sales_department_phone_2" class="flex items-center justify-between gap-1">
                Отдел продаж (Дарья)
                <SalesDepartmentPhone2 class="font-medium md:hover:text-navHoverColor transition"/>
            </div>
            <div v-if="contacts.commerce_department_phone" class="flex items-center justify-between gap-1">
                Отдел коммерции
                <CommerceDepartmentPhone class="font-medium md:hover:text-navHoverColor transition"/>
            </div>
            <div v-if="contacts.logistics_department_phone" class="flex items-center justify-between gap-1">
                Отдел логистики
                <LogisticDepartmentPhone class="font-medium md:hover:text-navHoverColor transition"/>
            </div>
        </div>
        <div @click.prevent="callbackStore.showBaseCallbackPopup"
             class="flex items-center justify-center w-full text-black border-2 border-baseColor rounded md:hover:bg-baseColor transition text-base font-medium text-center px-5 py-2.5 cursor-pointer mb-3">
            <div class="flex items-center gap-1">
                <IconPhone class="w-6 h-6"/>
                Обратный звонок
            </div>
        </div>
        <div class="flex flex-col gap-2 mb-3">
            <a v-if="contacts.whatsapp" :href="contacts.whatsapp" target="_blank"
               class="w-full flex items-center gap-2 md:hover:text-whatsapp transition">
                <IconWhatsApp class="min-w-6 min-h-6 max-w-6 max-h-6 text-whatsapp"/>
                Написать WhatsApp
            </a>
            <a v-if="contacts.telegram" :href="contacts.telegram" target="_blank"
               class="w-full flex items-center gap-2 md:hover:text-telegram transition">
                <IconTelegram class="min-w-6 min-h-6 max-w-6 max-h-6 text-telegram"/>
                Написать Telegram
            </a>
            <a v-if="contacts.info_mail" :href="'mailto:' + contacts.info_mail" target="_blank"
               class="w-full flex items-center gap-2 md:hover:text-navHoverColor transition">
                <IconEnvelope class="min-w-6 min-h-6 max-w-6 max-h-6 text-baseColor"/>
                {{ contacts.info_mail }}
            </a>
            <a v-if="contacts.address" :href="contacts.yandex_map_link" target="_blank"
               class="w-full flex items-center gap-2 md:hover:text-navHoverColor transition text-xs">
                <IconMapPoint class="min-w-6 min-h-6 max-w-6 max-h-6 text-navHoverColor"/>
                {{ contacts.address }}
            </a>
        </div>
        <div>
            <i>График работы: </i>пн-вс: 08:00 - 20:00
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>

